// @flow

import PropTypes from 'prop-types';
import React, { Component } from 'react';
//import Slider from 'react-nouislider';
import i18n from 'kodyl-js/i18n/react';

const Slider = __CLIENT__ ? require('./nouislider').default : null; // react-

@i18n
class RangeSlider extends Component {
  static propTypes = {
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onSlide: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  static defaultProps = {
    anchorLeft: false,
    direction: 'ltr'
  };

  onSlide = values => {
    this.props.onSlide(Number(values[0]), this.props.parentState);
  };

  render() {
    const {
      min,
      max,
      step,
      value,
      headline,
      label,
      measurement,
      direction,
      anchorLeft,
      labelTop
    } = this.props;
    const labelComp = (
      <div>
        {headline ? <h4>{headline}</h4> : null}
        <div className={`slider-label ${labelTop ? '' : 'slider-label-below'}`}>
          {`${label}: `}
          <span className="slider-lower">
            {value === (anchorLeft ? max : min)
              ? this.i18n('Any')
              : `${value} ${measurement}`}
          </span>
        </div>
      </div>
    );

    return Slider ? (
      <div
        className={
          anchorLeft ? 'anchor-left form-slider' : 'anchor-right form-slider'
        }
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        {labelTop ? labelComp : null}

        <Slider
          range={{ min, max }}
          step={step}
          defaultStart={[value]}
          onSlide={this.onSlide}
          direction={direction}
          connect={anchorLeft ? [true, false] : [false, true]}
        />
        {!labelTop ? labelComp : null}
      </div>
    ) : null;
  }
}

export default RangeSlider;
